module.exports = angular.module('cartographer.plugin.layer.storm', [])

_ = require 'underscore'

module.exports.run $DI (crtLayer, stormPhosphatesLayer) ->
  crtLayer.registerPlugin(stormPhosphatesLayer)
  return

module.exports.factory "stormPhosphatesLayer", $DI (
  crtMarkerColor
  crtFeatureLayer
  crtAttributeLayer
  crtMapCollaborationModel
  crtMapPermissionModel
  stormPhosphatesLevel
  stormPhosphatesLevelTrend
) ->
  crtFeatureLayer.create({
    id: "StormPhosphates"
    name: "Phosphates"
    atlasMapId: "StormPhosphates"
    defaultMapEngine: "atlas"
    selectionRadius: 500
    attributeGroups: [
      crtFeatureLayer.createAttributeGroup("Location", "Location", [
        crtAttributeLayer.createAutoLookup("riverName", "River", null)
        crtAttributeLayer.createLookup("level", "Level at Nearest Gauge", null, [
          { value: stormPhosphatesLevel.High   , color: crtMarkerColor.hue(60)  , label: "High"   }
          { value: stormPhosphatesLevel.Normal , color: crtMarkerColor.hue(180) , label: "Normal" }
          { value: stormPhosphatesLevel.Low    , color: crtMarkerColor.hue(300) , label: "Low"    }
        ])
        crtAttributeLayer.createLookup("levelTrend", "Level Trend at Nearest Gauge", null, [
          { value: stormPhosphatesLevelTrend.Rising  , color: crtMarkerColor.hue(60)  , label: "Rising"  }
          { value: stormPhosphatesLevelTrend.Steady  , color: crtMarkerColor.hue(180) , label: "Steady"  }
          { value: stormPhosphatesLevelTrend.Falling , color: crtMarkerColor.hue(300) , label: "Falling" }
        ])
      ])
      crtFeatureLayer.createAttributeGroup("Measurements", "Measurements", [
        crtAttributeLayer.createRange("phosphate", "Phosphates", "ppm", [
          { minValue: 0    , maxValue: 0.05      , color: crtMarkerColor.quality(15 / 20) }
          { minValue: 0.05 , maxValue: 0.25      , color: crtMarkerColor.quality(10 / 20) }
          { minValue: 0.25 , maxValue: 0.5       , color: crtMarkerColor.quality(9 / 20) }
          { minValue: 0.5  , maxValue: 0.75      , color: crtMarkerColor.quality(8 / 20) }
          { minValue: 0.75 , maxValue: 1.0       , color: crtMarkerColor.quality(7 / 20) }
          { minValue: 1.0  , maxValue: 1.25      , color: crtMarkerColor.quality(6 / 20) }
          { minValue: 1.25 , maxValue: 1.5       , color: crtMarkerColor.quality(5 / 20) }
          { minValue: 1.5  , maxValue: 1.75      , color: crtMarkerColor.quality(4 / 20) }
          { minValue: 1.75 , maxValue: 2.0       , color: crtMarkerColor.quality(3 / 20) }
          { minValue: 2.0  , maxValue: 2.25      , color: crtMarkerColor.quality(2 / 20) }
          { minValue: 2.25 , maxValue: 2.5       , color: crtMarkerColor.quality(1 / 20) }
          { minValue: 2.5  , maxValue: undefined , color: crtMarkerColor.quality(0 / 20) }
        ])
      ])
    ]
  })
